module.exports = __webpack_public_path__ + "files/362e59c6ef94d0c4bc4addc0c0cad34b.png";